import React from 'react';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';

import { Controller } from "react-hook-form";

interface IProps {
  name: string
  error?: object
  label?: string
  control: any
  isRequired?: boolean
  disabled?: boolean
  type?: string
}

const InputField = React.forwardRef<HTMLInputElement, IProps>((props: IProps, ref) => {
  const { name, label, control, isRequired, disabled} = props;

  return (
    <FormControl fullWidth>
      <Controller
        control={control}
        name={name}
        render={({
          field: { onChange, onBlur, value, name },
          fieldState: { error },
        }) => (
          <TextField
            onBlur={onBlur} // notify when input is touched
            onChange={onChange} // send value to hook form
            value={value || ''}
            disabled={disabled}
            error={!!error}
            helperText={error ? error.message : null}
            required={isRequired}
            label={label}
            inputRef={ref}
            inputProps={{
              'data-testid': name
            }}
          />
        )}
      />
    </FormControl>
  );
});

InputField.defaultProps = {
  isRequired: false,
  disabled: false,
};

export { InputField };
